import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { UsersService } from '@services/users.service';
import { User } from '@classes/user/user';


@Injectable()
export class UsersResolver implements Resolve<User[]> {
    constructor(
        private usersSrv: UsersService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.usersSrv.getList()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
